import { Component, OnInit ,Inject} from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-front-side',
  templateUrl: './front-side.component.html',
  styleUrls: ['./front-side.component.css']
})
export class FrontSideComponent implements OnInit {

  ModalTopic: any;
  FilePath: any;
  html:any;
  DontColse:boolean=false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _mdr: MatDialogRef<FrontSideComponent>,
    private sanitizer: DomSanitizer
  ) {
    this.ModalTopic = data.ModalTopic;
      this.FilePath = data.FilePath;
      this.DontColse = data.DontClose == true ? false : true;
   }

  ngOnInit(): void {
    if(this.ModalTopic=='Video'){
      this.html = this.sanitizer.bypassSecurityTrustHtml('<video id="fst-video" loop autoplay muted style="max-width: 500px;"><source src='+this.FilePath+' type="video/mp4"></video>') ;
    }else if(this.ModalTopic=='Img'){
      this.html = this.sanitizer.bypassSecurityTrustHtml('<img height="auto" class="img-responsive stn_img" src="'+this.FilePath+'">') ;
    }
    else if(this.ModalTopic=='TXT'){
      this.html = this.sanitizer.bypassSecurityTrustHtml('<span>'+this.FilePath+'</span>') ;
    }
  }

  CloseDialog() {
    this._mdr.close(false)
  }

}
